import Dashboard from "../../pages/hire-talent/dashboard";
import JobDetails from "../../pages/common/JobDetails";
import JobPost from "../../pages/hire-talent/JobPost";
import MyProjects from "../../pages/hire-talent/MyProjects";
import Inbox from "../../pages/hire-talent/Inbox";
import Profile from "../../pages/hire-talent/Profile";
import EditProfile from "../../pages/hire-talent/EditProfile";
import Settings from "../../pages/hire-talent/Settings";
import Applicants from "../../pages/hire-talent/Applicants";

export const hireTalentPaths = {
  Dashboard: "/hire-talent/dashboard",
  PostJobs: "/hire-talent/job-post",
  JobDetails: "/hire-talent/job-details",
  MyProjects: "/hire-talent/my-projects",
  Inbox: "/hire-talent/inbox",
  Profile: "/hire-talent/profile",
  EditProfile: "/hire-talent/profile/edit",
  Settings: "/hire-talent/settings",
  Applicants: "/hire-talent/applicants",
};

export const AllHireTalentRoutes = [
  {
    name: "Dashboard",
    path: hireTalentPaths?.Dashboard,
    element: <Dashboard />,
    isPrivate: false,
  },
  {
    name: "Job Post",
    path: hireTalentPaths?.PostJobs,
    element: <JobPost />,
    isPrivate: false,
  },
  {
    name: "JobDetails",
    path: hireTalentPaths.JobDetails,
    element: <JobDetails />,
    isPrivate: false,
  },
  {
    name: "MyProjects",
    path: hireTalentPaths?.MyProjects,
    element: <MyProjects />,
    isPrivate: false,
  },
  {
    name: "Inbox",
    path: hireTalentPaths?.Inbox,
    element: <Inbox />,
    isPrivate: false,
  },
  {
    name: "Profile",
    path: hireTalentPaths?.Profile,
    element: <Profile />,
    isPrivate: false,
  },
  {
    name: "Edit Profile",
    path: hireTalentPaths?.EditProfile,
    element: <EditProfile />,
    isPrivate: false,
  },
  {
    name: "Settings",
    path: hireTalentPaths?.Settings,
    element: <Settings />,
    isPrivate: false,
  },
  {
    name: "Applicants",
    path: hireTalentPaths?.Applicants,
    element: <Applicants />,
    isPrivate: false,
  },
];
